import { Footer2 ,TopBanner,Detail} from "../../components";
const ContactUs = ({props}) =>{
    return(
        <>
      
      <TopBanner>
        تماس با ما
        </TopBanner>
      <Detail/>
      
        </>
    )
}
export default ContactUs;